import { TrainingData, TrainingDataModification } from "./../types/trainingData.type";
import axios from "./api";
import { responseHandlerDefault, responseHandlerUpload } from "../utils/handler.util";
import { ElMessage } from "element-plus";
import { Filter, OrderByCondition } from "@/types/filter.type";

/**
 * Obtener los datos
 * @param samplingPointOffline
 * @returns
 */
export const getvisualizeTrainingData = (
  page?: number,
  size?: number,
  filter?: Filter,
  order?: OrderByCondition
) => {
  const params: { page?: number; size?: number; filter?: Filter; order?: OrderByCondition } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  if (order) {
    params.order = order;
  }
  return axios.get(`/trainingdata/visualize`, { params }).then(responseHandlerDefault);
};

export const downloadTrainingData = (
  page?: number,
  size?: number,
  filter?: Filter,
  order?: OrderByCondition
) => {
  const params: { page?: number; size?: number; filter?: Filter; order?: OrderByCondition } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  if (order) {
    params.order = order;
  }
  return axios.get(`/trainingdata/download`, { params, responseType: "blob" }).then((res) => {
    responseHandlerDefault(res);
    const match = res.headers["content-disposition"]?.match(/filename\s*=\s*"(.+)"/i);
    const fileName = match && match[1] ? match[1] : "report.csv";
    return { fileName, url: URL.createObjectURL(res.data) };
  });
};

export const getDataWithCleanningAutomatic = (
  samplingPointOffline: TrainingData[]
): Promise<TrainingData[]> => {
  return axios
    .post<TrainingData[]>(`/trainingdata/getcleanningautomatic`, samplingPointOffline)
    .then(responseHandlerDefault);
};

export const postTrainingData = (samplingPointOffline: TrainingData[]): Promise<TrainingData[]> => {
  return axios
    .post<TrainingData[]>(`/trainingdata`, samplingPointOffline)
    .then(responseHandlerUpload)
    .catch((error: any) => {
      if (error.response) {
        // La solicitud fue realizada y el servidor respondió con un código de estado no exitoso
        if (error.response.status === 409) {
          // Código de estado 409 indica conflicto (datos duplicados)
          ElMessage.error("Datos duplicados");
          // Muestra el mensaje de error al usuario o toma alguna acción apropiada
        } else {
          ElMessage.error("Error desconocido:", error.response.data.message);
          // Maneja otros errores aquí
        }
      } else if (error.request) {
        // La solicitud fue realizada, pero no se recibió respuesta
        ElMessage.error("No se recibió respuesta del servidor");
      } else {
        // Se produjo un error durante la configuración de la solicitud
        ElMessage.error("Error al configurar la solicitud:", error.message);
      }
      return "error";
    });
};

export const postTrainingDataModification = (
  trainingDataModification: TrainingDataModification[]
): Promise<boolean> => {
  return axios
    .post<TrainingDataModification>(`/trainingdata/modification`, trainingDataModification)
    .then(responseHandlerUpload)
    .catch((error: any) => {
      ElMessage.error("Error al guardar", error.message);
      return false;
    });
};
export const updateTmoaString = (
  containerId: number | undefined,
  samplingPointType: string,
  origin: string,
  tmoaString: string
) => {
  return axios
    .post(`/trainingdata/tmoastring`, {
      containerId: containerId,
      samplingPointType: samplingPointType,
      origin: origin,
      tmoaString: tmoaString,
    })
    .then(responseHandlerDefault);
};

export const updateTrainingData = (trainingData: TrainingData[]): Promise<TrainingData[]> => {
  // JSON.stringify(dataUpload)
  return axios.put<TrainingData[]>(`/trainingdata`, trainingData).then(responseHandlerDefault);
};
